export const getCdekTrackingUrl = (tracking: string) =>
  `https://www.cdek.ru/ru/tracking/?order_id=${encodeURIComponent(tracking)}`
